// @flow
import { openDialog } from '../../base/dialog/actions';
import { IconLobby } from '../../base/icons/svg';
import AbstractButton from '../../base/toolbox/components/AbstractButton';
// import { KickToLobbyDialog } from '.';
import KickToLobbyDialog from './web/KickToLobbyDialog';
;
/**
 * An abstract remote video menu button which kicks the remote participant back to lobby.
 */
export default class AbstractKickToLobbyButton extends AbstractButton {
    constructor() {
        super(...arguments);
        this.accessibilityLabel = 'toolbar.accessibilityLabel.kick';
        this.icon = IconLobby;
        this.label = 'videothumbnail.kickToLobby';
    }
    /**
     * Handles clicking / pressing the button, and kicks the participant back to lobby.
     *
     * @private
     * @returns {void}
     */
    _handleClick() {
        const { dispatch, participantID } = this.props;
        dispatch(openDialog(KickToLobbyDialog, { participantID }));
    }
}
